/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PinThreadRequest
 */
export interface PinThreadRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PinThreadRequest
     */
    pinned: boolean;
}

/**
 * Check if a given object implements the PinThreadRequest interface.
 */
export function instanceOfPinThreadRequest(value: object): value is PinThreadRequest {
    if (!('pinned' in value) || value['pinned'] === undefined) return false;
    return true;
}

export function PinThreadRequestFromJSON(json: any): PinThreadRequest {
    return PinThreadRequestFromJSONTyped(json, false);
}

export function PinThreadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PinThreadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'pinned': json['pinned'],
    };
}

export function PinThreadRequestToJSON(json: any): PinThreadRequest {
    return PinThreadRequestToJSONTyped(json, false);
}

export function PinThreadRequestToJSONTyped(value?: PinThreadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pinned': value['pinned'],
    };
}

